import * as React from "react";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import Panel from "./presentational/Panel";
import Hint from "./presentational/Hint";
import {useIntl} from "react-intl";

type Props = {}

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ProjectPaymentViewProps = Props & ConnectedProps<typeof connector>;

const ProjectPaymentView: React.FC<ProjectPaymentViewProps> = (props) => {
    const intl = useIntl();
    return (
        <>
            <Panel headline={intl.formatMessage({id: 'view.projectPayment.headline'})}>
                <Hint>{intl.formatMessage({id: 'view.projectPayment.notImplemented'})}</Hint>
            </Panel>
        </>
    )
}

export default connector(ProjectPaymentView);
